export class ImageUploadImageModel {
  id: string;
  name: string;
  label: string;
  resolution: string;
  url: string;
  filetype: string;
  imagedata: string;
  resized: Boolean;
  constructor(data?) {
    const imageData = data || {};
    this.id = imageData.id;
    this.name = imageData.fileName;
    this.label = imageData.label;
    this.resolution = imageData.resolution;
    this.resized = imageData.resized;
    // Check if uri starts with 'http' and replace with 'https'
    this.url = imageData && imageData.uri && imageData.uri.startsWith('http:') ? imageData.uri.replace('http:', 'https:') : imageData.uri;
    this.imagedata = imageData.value;
    this.filetype = imageData.fileType;
  }
}



// WEBPACK FOOTER //
// ./src/app/image-admin/image-models/image-upload-image.model.ts